import { ViewLayoutStatus } from './view-layout-status.enum';

export class LayoutDefault {
  constructor (
    public status: ViewLayoutStatus = ViewLayoutStatus.Hide,
    public enable = true
    ) {}
}

export class LogoLayout extends LayoutDefault {
  constructor(
    public isHyperLink = true
  ) {
    super();
  }
}

export class DrawerLayout extends LayoutDefault {
  constructor(
    public isExpandedInitially = false
  ) {
    super();
  }
}


export class ViewLayoutModel {
  audio: LayoutDefault;
  camera: LayoutDefault;
  chapterList: LayoutDefault;
  column: LayoutDefault;
  description: LayoutDefault;
  drawer: DrawerLayout;
  fullscreen: LayoutDefault;
  help: LayoutDefault;
  labelInfo: LayoutDefault;
  labelList: LayoutDefault;
  logo: LogoLayout;
  media: LayoutDefault;
  menu: LayoutDefault;
  nodeInfo: LayoutDefault;
  pagination: LayoutDefault;
  presenter: LayoutDefault;
  reset: LayoutDefault;
  search: LayoutDefault;
  toolbar: LayoutDefault;
  tools: LayoutDefault;
}
